import { ComponentProps, ReactNode } from 'react';
import { CalendarIcon, ChevronDown } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  FIELD_PLACEHOLDER_TEXT_CLASS_NAMES,
  type FieldSize,
  inputVariants,
} from '@/components/ui/input';

import { cn } from '@/lib/utils';

type PickerTriggerProps = Omit<
  ComponentProps<typeof Button>,
  'size' | 'children'
> & {
  fieldSize?: FieldSize;
  isOpen: boolean;
  isInvalid?: boolean;
  displayValue: string;
  placeholder?: string;
  clearButton?: ReactNode;
};

const PickerTrigger = (props: PickerTriggerProps) => {
  const {
    fieldSize = 'md',
    isOpen,
    isInvalid,
    displayValue,
    placeholder,
    clearButton,
    className,
    ...restProps
  } = props;

  return (
    <Button
      variant="field"
      type="button"
      aria-invalid={isInvalid}
      className={cn(
        'justify-start text-left',
        inputVariants({ kind: 'trigger', size: fieldSize }),
        className,
      )}
      {...restProps}
    >
      <CalendarIcon className="size-4 shrink-0" />
      <span
        className={cn(
          'flex-1 truncate',
          !displayValue && [
            'text-muted-foreground',
            FIELD_PLACEHOLDER_TEXT_CLASS_NAMES[fieldSize],
          ],
        )}
      >
        {displayValue || placeholder || ' '}
      </span>
      {clearButton}
      <ChevronDown
        className={cn(
          'size-4 shrink-0 transition-transform duration-200',
          isOpen && 'rotate-180',
        )}
      />
    </Button>
  );
};

export { PickerTrigger };
export type { PickerTriggerProps };
